import { render } from "./MainLayout.vue?vue&type=template&id=6572a3df"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6572a3df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6572a3df', script)) {
    api.reload('6572a3df', script)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=6572a3df", () => {
    api.rerender('6572a3df', render)
  })

}

script.__file = "src/layout/MainLayout.vue"

export default script